<form class="entry-page-form">
    <div class="text-wrapper">
        <h2 class="title" *ngIf="model.msg === 'organization' || model.msg === 'professional'">
            Please verify your email to complete the registration. Email with the link was sent to
            <span class="ch-highlight-text">{{ model.email }}</span>
        </h2>
        <h2 class="title" *ngIf="model.msg === 'password'">
            If an account with <span class="ch-highlight-text">{{ model.email }}</span> exists, a password reset link
            will be sent to that e-mail address.
        </h2>
        <h2 class="title" *ngIf="model.msg === 'reset_password'">
            The password for <span class="ch-highlight-text">{{ model.email }}</span> was successfully changed
        </h2>
        <h2 class="title" *ngIf="model.msg === 'profile_exists'">
            It looks like you have already completed registration with this e-mail address. Please sign in.
        </h2>
        <h2 class="title" *ngIf="model.msg === 'EXPIRED'">Your invitation has expired. Please sign in.</h2>
        <h2 class="title" *ngIf="model.msg === 'ACCOUNT_DELETED'">
            Sorry, your account has been disabled. <br />Please contact support team.
        </h2>
        <h2 class="title" *ngIf="model.msg === 'INVITATION_NO_VALID'">Your invitation is no longer valid.</h2>
        <h2 class="title" *ngIf="model.msg === 'CUSTOM_ERROR'">{{ model.text }}</h2>
    </div>
</form>
<footer class="entry-page-form-footer">
    Already have an account?<a class="cm-link" (click)="onSignInClick()" href="javascript:void(0)">Sign in</a>
</footer>
